import React, { useEffect, useState, useMemo } from "react";
import cx from "classnames";
import styles from "./WellbeingCentre/WellbeingCentre.module.scss";
import MainItem from "./WellbeingCentre/MainItem";
import { useRouteContext } from "@providers/RouteProvider";
import { formatTimeDisplay } from "@utils/dateFormatter";
import _ from "lodash";

export default function Facilities({ activeTab: tabPage, data }: any) {
  const { router } = useRouteContext();
  const tabs: any = useMemo(() => _.map(data, (item) => ({
    key: _.get(item, "tabKey"),
    image: _.get(item, "image"),
    title: _.get(item, "title"),
    content: _.get(item, "description"),
    shouldEnquire: false,
    moreInfo: {
      time: `${formatTimeDisplay(
        _.get(item, "openTime"),
        "HH:mm:ss"
      )} - ${formatTimeDisplay(_.get(item, "closeTime"), "HH:mm:ss")}`,
      phone: _.get(item, "phone"),
      floor: _.get(item, "location"),
    },
  })), [data]);
  const [activeTab, setActiveTab] = useState<string>("");
  useEffect(() => {
    if (router?.query?.wellnessSubTab) {
      setActiveTab(router?.query?.wellnessSubTab);
    }
  }, [router?.query]);
  useEffect(() => {
    if (_.has(tabs, "0.key") && !activeTab) {
      setActiveTab(_.get(tabs, "0.key", ""));
    }
  }, [tabPage, tabs, activeTab]);
  return (
    <div className={cx(styles.section)}>
      <MainItem
        swiperClass="Facilities"
        activeTab={activeTab}
        onChange={(key) => {
          setActiveTab(key);
        }}
        tabs={tabs}
      />
    </div>
  );
}
